import { Budget, initializeBudgetServiceData } from "@data/budget/budget";
import { ProductionEntity, Project, projectAka , ProjectCreativeExecutive} from "@data/project/project";
import { keyDatesDateServiceToUi, nullToTbd, tbdToNull } from "@shared/common-functions/data-conversion";
import { BehaviorSubject, Subject } from "rxjs";

export interface TaxCredits{
    taxCreditId?: number;
    projectId: number;
    description: string;
    comment: string;
    amount: number|null;
    computedAmount: string;
    displayOrder: number;
    preProdRefId?:number|null;
}

export interface TaxCreditsUi{
    taxCreditId?: number;
    projectId: number;
    description: string;
    comment: string;
    amount: string;
    computedAmount: string;
    displayOrder: number;
    order: number;
    preProdRefId?:number|null;
}

export interface KeyIssuesNotes{
    keyIssuesNotesId?: number|null;
    projectId: number;
    displayOrder: number;
    description: string;
}

export interface KeyIssuesNotesUi{
    keyIssuesNotesId?: number|null;
    projectId: number;
    order: number;
    displayOrder: number|null;
    description: string;
}

export interface KeyIssues{
    issuesNotesDTOS: KeyIssuesNotes[];
    projectDTO: Project;
    productionEntityList: null;
    taxCreditDTOS: TaxCredits[];
    budgetDTO: {budgetDTO:Budget, efcDTO:any}|any;
    projectAkaDTOList: projectAka[];
    projectCreativeExecutiveDTOList:ProjectCreativeExecutive[];
}

export interface KeyIssuesUi{
    issuesNotesDTOS: KeyIssuesNotesUi[];
    taxCreditDTOS: TaxCreditsUi[];
    productionEntity: number[];
    projectAkaDTOList: projectAka[];
    distributionFinance: string;
    currency:string;
    projectWbsid:string;
    projectMpmid:string;
    //creativeExecId:number|null;
    latestScriptTxt:string;
    noOfPages:number|any;
    greenlight:boolean;
    greenlightNet:number;
    actualFx:number|any;
    estBalTaxCreditFx:number|any;
    costToDt:number;
    studioId:number;
    isCommentsReordered:boolean;
    isTaxReordered:boolean;
    creativeEx:number[];
}

let defaultCommentBlankRows:number=3;

export let ProductionEntityList = new BehaviorSubject<ProductionEntity[]>([]);

export let creativeProjectExecList=new BehaviorSubject<ProjectCreativeExecutive[]>([]);

// export function initializeKeyIssuesData(){
//     let data:KeyIssuesUi={
//         issuesNotesDTOS: [],
//         taxCreditDTOS: [],
//         productionEntity: [],
//         projectAkaDTOList:[],
//         distributionFinance: "",
//         currency: "",
//         projectWbsid: "",
//         projectMpmid: "",
//         creativeExecId: null,
//         latestScriptTxt: "",
//         noOfPages: 0,
//         greenlight: false,
//         greenlightNet: 0,
//         actualFx: 0,
//         estBalTaxCreditFx: 0,
//         costToDt: 0,
//         studioId: NaN,
//         isCommentsReordered:false,
//         isTaxReordered:false,
//     }
//     return data;
// }

export function keyIssuesNotesUiToService(uData:KeyIssuesNotesUi[]){

    let sData:KeyIssuesNotes[]=[];
    let displayOrder=1;
    for(let k of uData){
        // if(k.description.trim()=='')
        //     continue;
        let data:KeyIssuesNotes={
            projectId: k.projectId,
            description: k.description,
            displayOrder: displayOrder,
        }
        k.displayOrder=displayOrder;
        if(k.keyIssuesNotesId)
            data.keyIssuesNotesId=k.keyIssuesNotesId;
        sData.push(data);
        displayOrder+=1;
    }
    return {
        uData: uData,
        sData: sData
    };
}

export function keyIssuesNotesServiceToUi(sData:KeyIssuesNotes[]|null, projectId:number, oldData?:KeyIssuesNotesUi[]){

    let uData:KeyIssuesNotesUi[]=[];

    if(oldData && sData){
        uData = oldData;
        for(let u of uData){
            for(let s of sData){
                if(s.displayOrder==u.displayOrder){
                    u.keyIssuesNotesId = s.keyIssuesNotesId;
                    break;
                }
            }
        }
    }
    else{
        if(sData==null){
            for(let i=1; i<=defaultCommentBlankRows; i=i+1){
                let emptyData:KeyIssuesNotesUi={
                    projectId:projectId,
                    description: '',
                    order: i,
                    displayOrder:0,
                    keyIssuesNotesId:null
                }
                uData.push(emptyData);
            }
        }
        else{
            for(let c of sData){
                let data:KeyIssuesNotesUi={
                    description: c.description,
                    displayOrder:c.displayOrder,
                    order: c.displayOrder,
                    projectId: c.projectId,
                    keyIssuesNotesId: c.keyIssuesNotesId
                }
                uData.push(data);
            }
        }

    }

    return uData;

}



export function taxCreditDataServiceToUi(projectId:number ,sData:TaxCredits[]|null, oldData?:TaxCreditsUi[]){

    let uData:TaxCreditsUi[]=[];

    if(sData!=null){
        for(let t of sData){
            let data:TaxCreditsUi={
                projectId: t.projectId,
                description: t.description,
                comment: t.comment,
                amount: nullToTbd(t.amount),
                computedAmount: t.computedAmount,
                displayOrder: t.displayOrder,
                taxCreditId: t.taxCreditId,
                order: t.displayOrder
            }
            if(t.preProdRefId)
                data.preProdRefId=t.preProdRefId;
            uData.push(data);
        }
    }
    else{
        let data:TaxCreditsUi={
            projectId: projectId,
            description: "",
            comment: "",
            amount: '0',
            computedAmount: '0K',
            displayOrder: 1,
            order: 1,
        }
        uData.push(data);
    }
    return uData;
}

export function taxCreditDataUiToService(uData:TaxCreditsUi[]){

    let sData:TaxCredits[]=[];
    let displayOrder=1;
    for(let t of uData){
        // if(t.description.trim()=='' && t.comment.trim()=='' && (t.amount.trim()=='0' || t.amount.trim()==''))
        //     continue;
        let data:TaxCredits={
            projectId: t.projectId,
            description: t.description? t.description.trim(): '',
            displayOrder: displayOrder,
            amount: t.amount? tbdToNull(t.amount): 0,
            comment: t.comment? t.comment.trim(): '',
            computedAmount: t.computedAmount,
        }
        t.displayOrder=displayOrder;
        if(t.taxCreditId)
            data.taxCreditId=t.taxCreditId;
        if(t.preProdRefId)
            data.preProdRefId=t.preProdRefId;
        sData.push(data);
        displayOrder+=1;
    }
    return {
        uData: uData,
        sData: sData
    };
}


export function keyIssuesDataServiceToUi(sData:KeyIssues, projectId:number){

    let uData:KeyIssuesUi={

        issuesNotesDTOS: [],

        projectAkaDTOList: sData.projectAkaDTOList? sData.projectAkaDTOList : [],

        taxCreditDTOS: [],

        productionEntity: [],
        distributionFinance: sData.projectDTO.distributionFinance? sData.projectDTO.distributionFinance : '||',
        currency: sData.projectDTO.currency? sData.projectDTO.currency : '|',
        projectWbsid: sData.projectDTO.projectWbsid?? '',
        projectMpmid: sData.projectDTO.projectMpmid?? '',
        latestScriptTxt: keyDatesDateServiceToUi(sData.projectDTO.latestScriptTxt),
        greenlight: sData.projectDTO.greenlight!=null? sData.projectDTO.greenlight : false,
        greenlightNet: sData.projectDTO.greenlightNet? sData.projectDTO.greenlightNet : 0,
        studioId: sData.projectDTO.studioId,
       // creativeExecId: sData.projectDTO.creativeExecId,

        noOfPages: sData.projectDTO.noOfPages,
        actualFx: null,
        estBalTaxCreditFx: null,
        costToDt: 0,

        isCommentsReordered: false,
        isTaxReordered: false,
        creativeEx:[],
    }

    uData.issuesNotesDTOS = keyIssuesNotesServiceToUi(sData.issuesNotesDTOS,projectId);

    if(sData.budgetDTO?.budgetDTO){
        uData.actualFx= sData.budgetDTO?.budgetDTO.actualFx?? null;
        uData.estBalTaxCreditFx= sData.budgetDTO?.budgetDTO.estBalTaxCreditFx?? null;
        uData.costToDt= sData.budgetDTO?.budgetDTO.costToDt?? 0;
    }

    if(sData.projectDTO.productionEntities && sData.projectDTO.productionEntities.length){
        uData.productionEntity=[];
        for(let p of sData.projectDTO.productionEntities){
            uData.productionEntity.push(p.productionEntityId);
        }
    }

    if(sData.projectCreativeExecutiveDTOList && sData.projectCreativeExecutiveDTOList.length){
        uData.creativeEx=[];
        for(let p of sData.projectCreativeExecutiveDTOList){
            uData.creativeEx.push(p.creativeExecId);
        }
    }
    uData.taxCreditDTOS = taxCreditDataServiceToUi(projectId, sData?.taxCreditDTOS??null);

    return uData;
}
